"use client";

import { useEffect } from "react";
import { useLocationStore } from "../locationStore";
import { DestinationIDData } from "@/lib/Types/DestinationIDData";

interface LocationStoreUpdaterProps {
  data: DestinationIDData[] | null;
}

/**
 * Client component that updates the location store with location data.
 * This component renders nothing - it only has the side effect of updating the store.
 *
 * Use this component to populate country/region/city names in the location store
 * based on breadcrumb data fetched server-side.
 */
export function LocationStoreUpdater({ data }: LocationStoreUpdaterProps) {
  const setLocationNames = useLocationStore((state) => state.setLocationNames);

  useEffect(() => {
    setLocationNames(data && data.length > 0 ? data : null);
  }, [data, setLocationNames]);

  return null;
}
